import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { SecurityPage } from './SecurityPage'

export const routes: RouteObject[] = [{ path: '/settings/security', element: <SecurityPage /> }]

// Здесь же объявлен сам раздел «Настройки»: другие подразделы (/settings/garmin, …) добавляют
// только свои пункты с parent: '/settings'.
export const nav: NavItem[] = [
  { path: '/settings', label: 'Настройки', icon: 'settings', mobile: 'more', order: 90 },
  {
    path: '/settings/security',
    label: 'Безопасность',
    icon: 'shield',
    mobile: null,
    order: 90,
    parent: '/settings',
  },
]
